import { DrawItemNames } from "../common/constants.lib";
import { CasiTileComponentName, ICasiTileComponent, ITileItem, TileItem } from "../common/obj.lib";
import { CurrentIterationComponent } from "./tiles/current-iteration/current-iteration.component";
import { MyWorkComponent } from "./tiles/my-work/my-work.component";
import { Test1Component } from "./tiles/test1/test1.component";


export const tileComponentPool: ICasiTileComponent[] = [
  { name: CasiTileComponentName.MyWork, component: MyWorkComponent },
  { name: CasiTileComponentName.CurrentBacklog, component: CurrentIterationComponent },
  { name: CasiTileComponentName.Test1, component: Test1Component }
];

// export class TileItem implements ITileItem {
//   static create(args: ITileItem) {
//     const { title, col, component, name, ref, row, colSpan, showAdd, menuContext } = args;
//     // console.log(`TileItem:create: `, JSON.stringify(args));
//     // console.log(`TileItem:create: showAdd`, showAdd, !!showAdd);
//     return new TileItem(
//       title, name, col, colSpan, component, ref, !!showAdd, menuContext ? menuContext : [], row,
//     );
//   }

//   constructor(
//     public title: string,
//     public name: string,
//     public col: number,
//     public colSpan: number,
//     public component: CasiTileComponentName,
//     public ref: DrawItemNames,
//     public showAdd: boolean,
//     public menuContext: any[],
//     public row?: number,
//   ) { }

//   get componentName() {
//     return `_${this.component}`;
//   };

//   get componentActual() {
//     let toReturn = tileComponentPool.find(t => t.name === this.component);
//     // console.log(`TileItem:componentActual:toReturn: `, toReturn);
//     if (!toReturn)
//       return undefined;
//     return toReturn?.component;
//   }
// }

export const tilesCollection: TileItem[] = [
  // TileItem.create(<ITileItem>{
  //   title: 'My Work',
  //   col: 3,
  //   name: 'TestTile1',
  //   component: CasiTileComponentName.MyWork,
  //   ref: DrawItemNames.MyWork,
  //   showAdd: false,
  //   colSpan: 3,
  //   menuContext: [{ text: "Select All" }]
  // }, tileComponentPool),
  TileItem.create(<ITileItem>{
    title: 'Current Iteration/backlog',
    col: 1,
    name: 'Current/backlog',
    showAdd: true,
    component: CasiTileComponentName.CurrentBacklog,
    ref: DrawItemNames.CurrentBacklog,
    colSpan: 5,
    menuContext: [
      { text: "Select All" },
      { text: "Clone panel" },
      { text: "Expand all iterations" },
      { text: "Collapse all iterations" },
      { text: "Hide empty iterations" },
      { text: "Split Current iteration and Backlog" },
      { text: "Add stories to bottom of panel" }
    ]
  }, tileComponentPool),
  // TileItem.create(<ITileItem>{
  //   title: 'Icebox',
  //   name: 'Icebox',
  //   col: 2,
  //   showAdd: false,
  //   component: CasiTileComponentName.Test1,
  //   ref: DrawItemNames.IceBox,
  //   colSpan: 2,
  //   menuContext: [{ text: "Select All" }]
  // }, tileComponentPool),
  // TileItem.create(<ITileItem>{
  //   title: 'Done',
  //   name: 'Done',
  //   col: 1,
  //   showAdd: false,
  //   component: CasiTileComponentName.Test1,
  //   ref: DrawItemNames.Done,
  //   colSpan: 2,
  //   menuContext: [{ text: "Select All" }]
  // }, tileComponentPool),
  // TileItem.create(<ITileItem>{
  //   title: 'Blocked',
  //   name: 'Blocked',
  //   col: 1,
  //   showAdd: false,
  //   component: CasiTileComponentName.Test1,
  //   ref: DrawItemNames.Blocked,
  //   colSpan: 2,
  //   menuContext: [{ text: "Select All" }]
  // }, tileComponentPool),
  // TileItem.create(<ITileItem>{
  //   title: 'Epics',
  //   name: 'Epics',
  //   col: 1,
  //   showAdd: false,
  //   component: CasiTileComponentName.Test1,
  //   ref: DrawItemNames.Epics,
  //   colSpan: 2,
  //   menuContext: [{ text: "Select All" }]
  // }, tileComponentPool),
  // TileItem.create(<ITileItem>{
  //   title: 'Labels',
  //   name: 'Labels',
  //   col: 1,
  //   showAdd: false,
  //   component: CasiTileComponentName.Test1,
  //   ref: DrawItemNames.Labels,
  //   colSpan: 2,
  //   menuContext: [{ text: "Select All" }]
  // }, tileComponentPool),
  // TileItem.create(<ITileItem>{
  //   title: 'Project history',
  //   name: 'Project history',
  //   col: 1,
  //   showAdd: true,
  //   component: CasiTileComponentName.Test1,
  //   ref: DrawItemNames.ProjectHistory,
  //   colSpan: 2,
  //   menuContext: [{ text: "Select All" }]
  // }, tileComponentPool)
];
